import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StyledTab, StyledTabs } from "./AdminSettingPanel";
import ChartList from "./ChartSettingList";

const useStyles = makeStyles({
	settingTopBox: {
		display: 'flex',
		flexDirection: 'column',
	},
	settingTab: {
	},
	settingBody: {
		flexGrow: 1,
		marginTop: '-1px',
		border: '1px solid #a7a7a7',
		overflow: 'hidden',
	},
});

export function ChartSettingBox() {
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const classes = useStyles();
	const {t} = useTranslation();

	return (
		<div className={clsx(classes.settingTopBox)} style={{ height: '100%' }}>
			<Box className={classes.settingTab}>
				<StyledTabs
					value={value}
					onChange={handleChange}
				>
					<StyledTab label={t('Chart List')} />
				</StyledTabs>
			</Box>
			<Box className={classes.settingBody}>
				{value === 0 && <ChartList />}
			</Box>
		</div>
	);
}
